import {lazy} from 'react';

export const EditorContentLazy = lazy(() => import(/* webpackChunkName: "editorContent" */ '.'));
